import React, { useState } from 'react';
import './locationslogistictemplate.css';
import logo from './images/KrossKast_Logo-red.png';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import AuthenticatedUserMenu from './components/AuthenticatedUserMenu';
import { useBrand } from './context/BrandContext';

const LocationsLogisticTemplate = () => {
  const navigate = useNavigate();
  const { brandId } = useParams(); // Get brand ID from URL params
  const { currentBrand } = useBrand();
  
  const [selectedBrand, setSelectedBrand] = useState({
    id: brandId || '1',
    name: currentBrand.name,
    type: currentBrand.type
  });

  // Logistics fields load from API when available — no invented contacts.
  const [lltData, setLltData] = useState({
    deliverySchedule: {
      monday: "9:00 AM - 5:00 PM",
      tuesday: "9:00 AM - 5:00 PM", 
      wednesday: "9:00 AM - 5:00 PM",
      thursday: "9:00 AM - 5:00 PM",
      friday: "9:00 AM - 5:00 PM",
      saturday: "10:00 AM - 2:00 PM",
      sunday: "Closed"
    },
    contactInfo: {
      primaryContact: "",
      phone: "",
      email: "",
      emergencyContact: ""
    },
    logistics: {
      preferredCarrier: "",
      specialInstructions: "",
      packagingRequirements: "",
      deliveryNotes: ""
    },
    locations: []
  });

  const handleBackToBrands = () => {
    navigate('/brand-manager');
  };

  return (
    <div className="master-account-page">
      <div className="top-nav">
        <img src={logo} alt="KrossKast" className="nav-logo" />
        <AuthenticatedUserMenu />
      </div>
      
      <div className="master-content">
        <Sidebar />
        <div className="main-area">
          <div className="llt-header">
            <button onClick={handleBackToBrands} className="back-button">
              ← Back to Brands
            </button>
            <h1>Locations Logistic Template (LLT)</h1>
            <p className="brand-info">{selectedBrand.name} - {selectedBrand.type}</p>
          </div>

          <div className="llt-content">
            {/* Delivery Schedule Section */}
            <div className="llt-section">
              <h2>Delivery Schedule</h2>
              <div className="schedule-grid">
                {Object.entries(lltData.deliverySchedule).map(([day, time]) => (
                  <div key={day} className="schedule-item">
                    <span className="day">{day.charAt(0).toUpperCase() + day.slice(1)}</span>
                    <span className="time">{time}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Information Section */}
            <div className="llt-section">
              <h2>Contact Information</h2>
              <div className="contact-grid">
                <div className="contact-item">
                  <label>Primary Contact:</label>
                  <span>{lltData.contactInfo.primaryContact}</span>
                </div>
                <div className="contact-item">
                  <label>Phone:</label>
                  <span>{lltData.contactInfo.phone}</span>
                </div>
                <div className="contact-item">
                  <label>Email:</label>
                  <span>{lltData.contactInfo.email}</span>
                </div>
                <div className="contact-item">
                  <label>Emergency Contact:</label>
                  <span>{lltData.contactInfo.emergencyContact}</span>
                </div>
              </div>
            </div>

            {/* Logistics Section */}
            <div className="llt-section">
              <h2>Logistics Information</h2>
              <div className="logistics-grid">
                <div className="logistics-item">
                  <label>Preferred Carrier:</label>
                  <span>{lltData.logistics.preferredCarrier}</span>
                </div>
                <div className="logistics-item">
                  <label>Special Instructions:</label>
                  <span>{lltData.logistics.specialInstructions}</span>
                </div>
                <div className="logistics-item">
                  <label>Packaging Requirements:</label>
                  <span>{lltData.logistics.packagingRequirements}</span>
                </div>
                <div className="logistics-item">
                  <label>Delivery Notes:</label>
                  <span>{lltData.logistics.deliveryNotes}</span>
                </div>
              </div>
            </div>

            {/* Locations Section */}
            <div className="llt-section">
              <h2>Associated Locations</h2>
              <div className="locations-table">
                <div className="table-header">
                  <span>Location Name</span>
                  <span>Address</span>
                  <span>Status</span>
                </div>
                {lltData.locations.map(location => (
                  <div key={location.id} className="table-row">
                    <span>{location.name}</span>
                    <span>{location.address}</span>
                    <span className={`status ${location.status.toLowerCase()}`}>
                      {location.status}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationsLogisticTemplate;
